import EventBus from '@/adready-vue/helpers/global/event-bus';
import advertiserReportsApi from '@/api/advertiser-reports';
import appConsoleDataLayer from '@/api/app-console-data';
import { CONVERGED_TV_SOLUTION_ID } from '@/constant';
import { buildQueryString } from '@/helpers/global/url-helpers';
import { formatDateForAPI } from '@/util/apiDateFormat';

const methods = {
  async getConversionPixelOptions(campaignIds, adGroups, dateRange) {
    const dates = dateRange === undefined ? this.dates : dateRange;
    const payload = {
      advertiser: this.advertiser ? this.advertiser.name : '',
      client: this.account ? this.account.name : '',
      campaignIds,
      adGroups,
      startDate: formatDateForAPI(dates?.startDate),
      endDate: formatDateForAPI(dates?.endDate),
    };
    const data = await appConsoleDataLayer.fetchConversionPixelOptions(
      this.advertiserId,
      this.activeSolutionId,
      payload
    );
    return data;
  },
  async getMediaTypes(campaignIds, adGroups, dateRange) {
    const dates = dateRange === undefined ? this.dates : dateRange;
    const payload = {
      advertiser: this.advertiser ? this.advertiser.name : '',
      client: this.account ? this.account.name : '',
      campaignIds,
      adGroups,
      startDate: formatDateForAPI(dates?.startDate),
      endDate: formatDateForAPI(dates?.endDate),
    };
    const data = await appConsoleDataLayer.fetchMediaTypeOptions(
      this.advertiserId,
      this.activeSolutionId,
      payload
    );
    const newData = [];
    if (data.length !== 0) {
      for (let i = 0; i < data.length; i++) {
        newData.push({ value: data[i], checked: true });
      }
    }
    return newData;
  },
  async getKeywords(campaignIds, adGroups, dateRange) {
    if (this.activeSolutionId === CONVERGED_TV_SOLUTION_ID) {
      return [];
    }

    const dates = dateRange === undefined ? this.dates : dateRange;
    const payload = {
      advertiser: this.advertiser ? this.advertiser.name : '',
      client: this.account ? this.account.name : '',
      campaignIds,
      adGroups,
      startDate: formatDateForAPI(dates?.startDate),
      endDate: formatDateForAPI(dates?.endDate),
    };
    const data = await appConsoleDataLayer.fetchKeywordOptions(
      this.advertiserId,
      this.activeSolutionId,
      payload
    );
    const newData = [];
    if (data.length !== 0) {
      for (let i = 0; i < data.length; i++) {
        newData.push({ value: data[i], checked: false });
      }
    }
    return newData;
  },
  async getAudiences(campaignIds, adGroups, dateRange) {
    const dates = dateRange === undefined ? this.dates : dateRange;
    const payload = {
      advertiser: this.advertiser ? this.advertiser.name : '',
      client: this.account ? this.account.name : '',
      campaignIds,
      adGroups,
      startDate: formatDateForAPI(dates?.startDate),
      endDate: formatDateForAPI(dates?.endDate),
    };
    const data = await appConsoleDataLayer.fetchAudienceOptions(
      this.advertiserId,
      this.activeSolutionId,
      payload
    );
    const keysSet = new Set();
    const filterOptions = [];
    // filter out duplicates
    data?.forEach((d) => {
      if (!keysSet.has(d.key)) {
        keysSet.add(d.key);
        filterOptions.push({ key: d.value, value: d.key, checked: false });
      }
    });
    return filterOptions;
  },
  async getPublishers() {
    const data = await advertiserReportsApi.publishers(
      this.advertiser ? this.advertiser.id : 0,
      buildQueryString({
        advertiser: this.advertiser ? this.advertiser.name : '',
        client: this.account ? this.account.name : '',
        endDate: formatDateForAPI(this.dates.endDate),
        startDate: formatDateForAPI(this.dates.startDate),
      })
    );
    const filterOptions = [];
    if (data.length) {
      data?.forEach((d) => filterOptions.push({ ...d, checked: false }));
    }
    return filterOptions;
  },
  async getCreatives(campaignIds, adGroups, dateRange, selectedCreativeOptions = null) {
    const dates = dateRange === undefined ? this.dates : dateRange;
    const payload = {
      advertiser: this.advertiser ? this.advertiser.name : '',
      client: this.account ? this.account.name : '',
      campaignIds,
      adGroups,
      startDate: formatDateForAPI(dates?.startDate),
      endDate: formatDateForAPI(dates?.endDate),
    };
    const data = await appConsoleDataLayer.fetchCreativeOptions(
      this.advertiserId,
      this.activeSolutionId,
      payload
    );

    const filterOptions = [];

    if (this.isAdvanceFilterInOverview && !this.isMniReportDashboard) {
      const dates2 = this.dates;
      const payload2 = {
        advertiser: this.advertiser ? this.advertiser.name : '',
        client: this.account ? this.account.name : '',
        campaignIds,
        adGroups,
        startDate: formatDateForAPI(dates2?.startDate),
        endDate: formatDateForAPI(dates2?.endDate),
      };
      const data2 = await appConsoleDataLayer.fetchCreativeOptions(
        this.advertiserId,
        this.activeSolutionId,
        payload2
      );
      // Create a set of keys from list2
      const list2Keys = new Set(data2.map((item) => item.key));
      // Compare and flag items in list1
      const updatedList1 = data.map((item) => ({
        ...item,
        disabled: !list2Keys.has(item.key),
      }));

      const sortedList1 = updatedList1.sort((a, b) => {
        if (!a.disabled && b.disabled) return -1;
        if (a.disabled && !b.disabled) return 1;
        return 0;
      });
      //

      if (sortedList1.length) {
        sortedList1?.forEach((d) => filterOptions.push({ ...d, checked: false }));
      }
      if (selectedCreativeOptions !== null) {
        if (selectedCreativeOptions.length === 0) {
          this.$nextTick(() => {
            EventBus.$emit('update-creative-options', filterOptions);
          });
        } else {
          const selectedCreativesVal = selectedCreativeOptions.map((item) => item.value);
          filterOptions.forEach((item) => {
            if (selectedCreativesVal.includes(item.value) && !item.disabled) {
              item.checked = true;
            }
          });
          this.$nextTick(() => {
            EventBus.$emit('update-creative-options', filterOptions);
          });
        }
      }
    } else if (data.length) {
      data?.forEach((d) => filterOptions.push({ ...d, checked: false }));
    }

    return filterOptions;
  },
};

export default { methods };
